/**
 * Quick view facade: load quick-view.js on first Quick View click, then replay.
 */
(() => {
  const modal = document.querySelector("quick-view-modal");
  if (!modal) return;
  if (customElements.get("quick-view-modal")) return;

  const loader = window.BoltFeatureLoader;
  const jsSrc = (window.BoltAssets && window.BoltAssets.quickView) || modal.dataset.facadeJs;
  if (!loader || !jsSrc) return;

  const CLICK_SELECTOR = "[name='quick-view'], [data-quick-view]";
  let hydratePromise = null;
  let pendingTrigger = null;

  const hydrate = () => {
    if (customElements.get("quick-view-modal")) return Promise.resolve();
    if (hydratePromise) return hydratePromise;

    hydratePromise = loader
      .loadScript(jsSrc, "bolt-quick-view-js")
      .then(() => customElements.whenDefined("quick-view-modal"))
      .then(() => {
        document.removeEventListener("click", onFirstClick, true);
      })
      .catch((error) => {
        hydratePromise = null;
        console.error("Quick view facade failed to load", error);
        throw error;
      });

    return hydratePromise;
  };

  const onFirstClick = async (event) => {
    const trigger = event.target.closest(CLICK_SELECTOR);
    if (!trigger) return;
    if (customElements.get("quick-view-modal")) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    pendingTrigger = trigger;

    try {
      await hydrate();
      const replay = pendingTrigger;
      pendingTrigger = null;
      replay?.click();
    } catch (error) {
      pendingTrigger = null;
    }
  };

  document.addEventListener("click", onFirstClick, true);
})();
